import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AwsLogger {
  private readonly url = 'https://d6csauwlotdyu6bfhfnhefxbg40kypmv.lambda-url.us-east-1.on.aws/';

  constructor(private http: HttpClient) {}

  log(payload: any, error: any, success: boolean, flow?: string) {
    const clean = JSON.parse(JSON.stringify(payload));
    const contact = clean?.contacts?.contact?.[0];

    if (contact?.user?.password) contact.user.password = '***';
    if (contact?.user?.secretQA?.answer) contact.user.secretQA.answer = '***';

    return this.http.post(this.url, {
      payload: clean,
      error,
      success,
      flow
    });
  }
}
